var map = {
	"./auto-file.png": "5de7",
	"./excel.png": "d067",
	"./file.png": "859e",
	"./img.png": "eb1c",
	"./mp3.png": "73e7",
	"./pdf.png": "7119",
	"./ppt.png": "5387",
	"./txt.png": "d2af",
	"./unknown.png": "c044",
	"./video.png": "7eab",
	"./word.png": "3371",
	"./zip.png": "e02c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9990";